import { debounceTime, takeUntil } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { PurchaseOrderSetAction } from '../../../actions/purchase-order-actions/purchase-order.actions';
import { Subject, Subscription } from 'rxjs';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';

@Injectable()
export class PurchaseOrderSetCommand implements OnFieldChanged, OnDestroy {
  private textCache: string;
  private debounceSubject = new Subject();
  private _destroyed$ = new Subject();

  constructor(private store: Store<OrderBuilderState>) {
    this.debounceDispatcher();
  }

  onFieldChanged(text: string): void {
    this.debounceSubject.next(text);
  }

  debounceDispatcher(): Subscription {
    return this.debounceSubject.pipe(debounceTime(350), takeUntil(this._destroyed$)).subscribe((text: string) => {
      if (text !== this.textCache) {
        this.store.dispatch(new PurchaseOrderSetAction(text));
        this.textCache = text;
      } else {
        this.textCache = '';
      }
    });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}

/**
 * Same as PurchaseOrderSetCommand without textCache validation
 * Avoids issue for not setting purchaseOrder at STATE
 */
@Injectable()
export class PurchaseOrderRepeatSetCommand implements OnFieldChanged, OnDestroy {
  private debounceSubject = new Subject();
  private _destroyed$ = new Subject();

  constructor(private store: Store<OrderBuilderState>) {
    this.debounceDispatcher();
  }

  onFieldChanged(text: string): void {
    this.debounceSubject.next(text);
  }

  debounceDispatcher(): Subscription {
    return this.debounceSubject.pipe(debounceTime(350), takeUntil(this._destroyed$)).subscribe((text: string) => {
      this.store.dispatch(new PurchaseOrderSetAction(text));
    });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
